import { GENERIC_ERROR_MESSAGE } from '@/utils/constants'

// The gateway replies as { error: [{ code, message }] }; fall back to the response message, then the
// axios message, then a generic one.
export const apiErrorMessage = (error: unknown): string => {
  const err = error as {
    response?: { data?: { error?: { message?: string }[]; message?: string } }
    message?: string
  }
  return (
    err?.response?.data?.error?.[0]?.message ??
    err?.response?.data?.message ??
    err?.message ??
    GENERIC_ERROR_MESSAGE
  )
}
